import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import styles from './QuizNavigation.css';

function QuizNavigation({ hasBackButton, onBack, currentSlideIndex, totalSlides }) {
    return (
        <nav className={styles.root}>
            {hasBackButton && (
                <Button
                    iconLeft={{ name: 'chevronLeft' }}
                    className={styles.backButton}
                    type='secondary'
                    onClick={onBack}
                    rounded
                    buttonProps={{ 'aria-label': 'Go back' }}
                />
            )}
            <span className={styles.currentSlideText}>{currentSlideIndex} / {totalSlides}</span>
        </nav>
    );
}

QuizNavigation.propTypes = {
    hasBackButton: PropTypes.bool,
    onBack: PropTypes.func,
    currentSlideIndex: PropTypes.number,
    totalSlides: PropTypes.number
};

export { QuizNavigation };
